















import Vue from "vue";

export default Vue.extend({
  name: "AddBuyoutSuccess",
  props: {
    onClose: {
      type: Function,
      default: () => true,
    },
  },
});
